import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { HelmetProvider } from 'react-helmet-async';
import { PersistGate } from 'redux-persist/integration/react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './index.css';
import App from './App';
import { store, persistor } from './redux/store';
import { LanguageProvider } from './utils/i18n';
import { AlertProvider } from './utils/AlertContext';
import { SettingsProvider } from './utils/SettingsContext';
import { PermissionProvider } from './utils/PermissionContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <HelmetProvider>
          <SettingsProvider>
            <PermissionProvider>
              <LanguageProvider>
                <AlertProvider>
                  <BrowserRouter>
                    <App />
                    <ToastContainer
                      position="top-right"
                      autoClose={3000}
                      hideProgressBar={false}
                      newestOnTop={false}
                      closeOnClick
                      rtl={false}
                      pauseOnFocusLoss
                      draggable
                      pauseOnHover
                    />
                  </BrowserRouter>
                </AlertProvider>
              </LanguageProvider>
            </PermissionProvider>
          </SettingsProvider>
        </HelmetProvider>
      </PersistGate>
    </Provider>
  </React.StrictMode>
);
